<template>
  <slot />
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
})
</script>
